import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accolades-list-v3.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var AccoladesListV3 = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesListV3, _super);
    function AccoladesListV3(element) {
        return _super.call(this, element) || this;
    }
    AccoladesListV3.prototype.init = function () {
        this.carouselContainer = this.element.querySelector('.accolades-list-v3__carousel--swiper');
        this.carouselPagination = this.element.querySelector('.slider__pagination');
        this.carouselButtonNext = this.element.querySelector('.slider__nav--next');
        this.carouselButtonPrev = this.element.querySelector('.slider__nav--prev');
        this.carousel = new Swiper(this.carouselContainer, {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            pagination: {
                el: this.carouselPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.carouselButtonNext,
                prevEl: this.carouselButtonPrev,
            }
        });
    };
    AccoladesListV3.prototype.bindEvents = function () {
    };
    return AccoladesListV3;
}(Base));
export { AccoladesListV3 };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-v3/accolades-list-v3.component.ts
// module id = 776
// module chunks = 0